module.exports = __webpack_public_path__ + "static/media/it.78b17541.svg";